export const prerender = true;
export const ssr = true;

// This ensures client-side navigation still works
export const csr = true; 